import { guid, createGuid, guidNumber } from 'apps/builder/lib/utils'
import {
  addEntry,
  copyEntry,
} from 'apps/builder/store/actions/entries'
import {
  copySheet as copySheetAction,
  splitSheet as splitSheetAction,
  addSheet,
  addTableSheet,
  addListSheet,
  copyTableOrSimpleLoopSheet,
} from 'apps/builder/store/actions/sheets'

export const createNewEntry = ({ sheet_id, position, ...entry }) => {
  return addEntry({
    ...entry,
    guid: guid(),
    sheet_id,
    position,
    id: `new-${entry.id}-${Date.now()}`,
  })
}

export const addScreen = ({ count, name, autoFocus }) => {
  const sectionGuid = guidNumber()
  const sheetGuid = guidNumber()
  return addSheet({
    section_id: sectionGuid,
    sheet_type_id: 11,
    style: 0,
    autoFocus,
    placeholder: `Type screen name`,
    position: 0,
    id: sheetGuid,
    pdf_visibility: 0,
  })
}

export const addTable = ({
  count,
  name,
  autoFocus,
  keyField,
  sectionPosition,
}) => {
  const sectionGuid = guidNumber()
  const sheetGuid = guidNumber()
  const multiSheetGuid = guidNumber()
  const multiSectionGuid = guidNumber()

  return addTableSheet({
    section_id: sectionGuid,
    sheet_type_id: 15,
    style: 1,
    multiSheetGuid,
    multiSectionGuid,
    keyField: {
      ...keyField,
      guid: guid(),
    },
    autoFocus,
    placeholder: `Type table name`,
    position: 0,
    id: sheetGuid,
    sectionPosition,
  })
}

export const addList = ({
  autoFocus,
  keyField,
  sectionPosition,
}) =>
  addListSheet({
    section_id: guidNumber(),
    sheet_type_id: 15,
    style: 1,
    keyField: {
      ...keyField,
      guid: guid(),
    },
    autoFocus,
    placeholder: `Type list name`,
    position: 0,
    id: guidNumber(),
    sectionPosition,
  })

export const copyTableOrSimpleLoop = ({
  id,
  allSheets,
  allSheetsEntries,
  sectionId,
  multiSectionId,
}) => {
  const newSectionGuid = guidNumber()
  const newSheetGuid = guidNumber()
  const newMultiSheetGuid = guidNumber()
  const newMultiSectionGuid = guidNumber()

  return copyTableOrSimpleLoopSheet({
    parentSheetId: id,
    newSectionGuid,
    newSheetGuid,
    newMultiSheetGuid,
    newMultiSectionGuid,
    sheetsToCopy: allSheets,
    sectionsToCopy: [sectionId, multiSectionId],
    entriesToCopy: allSheetsEntries,
    seed: createGuid(),
  })
}

export const insertNewScreen = ({ sectionPosition, autoFocus, depth }) => {
  const sectionGuid = guidNumber()
  const sheetGuid = guidNumber()
  return addSheet({
    section_id: sectionGuid,
    placeholder: `Type screen name`,
    position: 0,
    id: sheetGuid,
    sheet_type_id: 11,
    sectionPosition,
    pdf_visibility: 0,
    autoFocus,
    depth,
  })
}

export const copySheet = ({ id, sectionId, parentSheet, sheetEntries }) =>
  copySheetAction({
    id,
    newId: guid(),
    sectionId,
    newSectionId: guid(),
    seed: createGuid(),
    parentSheet,
    sheetEntries,
  })

export const splitSheet = ({
  id,
  sectionId,
  position,
  parentSheet,
  sheetEntries,
}) =>
  splitSheetAction({
    id,
    newId: guidNumber(),
    sectionId,
    newSectionId: guidNumber(),
    position,
    parentSheet,
    sheetEntries,
  })
